import { render, staticRenderFns } from "./AccrualsTable.vue?vue&type=template&id=1886e635&scoped=true"
import script from "./AccrualsTable.vue?vue&type=script&lang=js"
export * from "./AccrualsTable.vue?vue&type=script&lang=js"
import style0 from "./AccrualsTable.vue?vue&type=style&index=0&id=1886e635&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886e635",
  null
  
)

export default component.exports